import { render, staticRenderFns } from "./TheDocumentData.vue?vue&type=template&id=00d4277a&scoped=true&"
import script from "./TheDocumentData.vue?vue&type=script&lang=js&"
export * from "./TheDocumentData.vue?vue&type=script&lang=js&"
import style0 from "./TheDocumentData.vue?vue&type=style&index=0&id=00d4277a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d4277a",
  null
  
)

export default component.exports